module.exports = __webpack_public_path__ + "static/media/cocktail.e08dc116.mp3";